import { Exam } from "../api-objects/Exam";
import { HealthPlan, MealPlan } from "../api-objects/HealthPlan";
import { BASE_URL, requestOptionsGET } from "../Constants";

export async function getMealPlans(
    userId: string,
    idToken: string,
): Promise<MealPlan[] | null> {
    try {
        const response = await fetch(`${BASE_URL}/api/meal-plans/user/${userId}`, requestOptionsGET(idToken));
        if (response.ok) {
            const mealPlans: MealPlan[] = await response.json();
            return mealPlans; 
        } else if (response.status === 401) {
            throw new Error("Session expired");
        } else if (response.status === 404) {
            console.warn(`Meal plan non trovato per user: ${userId}`)
            return null
        } else {
            throw new Error("Errore nel recuperare il meal plan");
        }
    } catch (error) {
        if (error instanceof Error)
            if (error.message.includes("Session expired")) {
                throw new Error("Session expired");
            } else if (error.message.includes("Nessun meal plan trovato")) {
                throw new Error(error.message);
            }
        throw new Error("An unexpected error occurred");
    }
}

export async function getHealthPlans(
    userId: string,
    idToken: string,
): Promise<HealthPlan[] | null> {
    try {
        const response = await fetch(`${BASE_URL}/api/health-plans/user/${userId}`, requestOptionsGET(idToken));
        if (response.ok) {
            const healthPlans: HealthPlan[] = await response.json();
            return healthPlans; 
        } else if (response.status === 401) {
            throw new Error("Session expired");
        } else if (response.status === 404) {
            console.warn(`Health plan non trovato per user: ${userId}`)
            return null
        } else {
            throw new Error("Errore nel recuperare l'health plan");
        }
    } catch (error) {
        if (error instanceof Error)
            if (error.message.includes("Session expired")) {
                throw new Error("Session expired");
            } else if (error.message.includes("Nessun health plan trovato")) {
                throw new Error(error.message);
            }
        throw new Error("An unexpected error occurred");
    }
}

export async function getHealthPlanPdf(
    userId: string,
    idToken: string,
    folder: string,
): Promise<Exam[]> {
    try {
        const response = await fetch(`${BASE_URL}/api/health-plans/user/${userId}/pdfs?folder=${folder}`, requestOptionsGET(idToken));
        if (response.ok) {
            const uploadUrlResponse = await response.json();
            return uploadUrlResponse
        } else if (response.status === 401) {
            throw new Error("Session expired");
        } else if (response.status === 404) {
            return []
        } else {
            throw new Error("Errore nel recuperare l'health plan");
        }
    } catch (error) {
        if (error instanceof Error)
            if (error.message.includes("Session expired")) {
                throw new Error("Session expired");
            } else if (error.message.includes("Nessun health plan trovato")) {
                throw new Error(error.message);
            }
        throw new Error("An unexpected error occurred");
    }
}

export async function getMealPlanPdfs(
    userId: string,
    idToken: string,
    folder: string,
): Promise<Exam[]> {
    try {
        const response = await fetch(`${BASE_URL}/api/meal-plans/user/${userId}/pdfs?folder=${folder}`, requestOptionsGET(idToken));
        if (response.ok) {
            const uploadUrlResponse = await response.json();
            return uploadUrlResponse
        } else if (response.status === 401) {
            throw new Error("Session expired");
        } else if (response.status === 404) {
            return []
        } else {
            throw new Error("Errore nel recuperare il meal plan");
        }
    } catch (error) {
        if (error instanceof Error)
            if (error.message.includes("Session expired")) {
                throw new Error("Session expired");
            } else if (error.message.includes("Nessun meal plan trovato")) {
                throw new Error(error.message);
            }
        throw new Error("An unexpected error occurred");
    }
}

export async function callUpdateHealthPlanDataApi(
    idToken: string,
    health_plan_id: string,
    data: any,
): Promise<any> {
    try {
        const response = await fetch(`${BASE_URL}/api/health-plans/checks/${health_plan_id}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify({
                data,
            }),
        })

        if (!response.ok) {
            throw new Error("Aggiornamento Health Plan errato");
        }

        return response;
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(error.message);
        } else {
            throw new Error("Errore durante l'aggiornamento dell'Health Plan");
        }
    }
}

export async function callUpdateMealPlanDataApi(
    idToken: string,
    meal_plan_id: string,
    data: any,
): Promise<any> {
    try {
        const response = await fetch(`${BASE_URL}/api/meal-plans/checks/${meal_plan_id}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify({
                data,
            }),
        })

        if (!response.ok) {
            throw new Error("Aggiornamento Meal Plan errato");
        }

        return response;
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(error.message);
        } else {
            throw new Error("Errore durante l'aggiornamento del Meal Plan");
        }
    }
}
